import { render } from "./AppButton.vue?vue&type=template&id=1249e2e0"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"
script.render = render

export default script